module.exports = {

	// browserSync: {
	// 	host   : 'vaccineinjurylegalteam.colab',
	// 	target : 'vaccineinjurylegalteam.colab'
	// },
	hosts: {
		'live'  : 'vaccineinjurylegalteam.com',
		'test'  : 'test-vaccineinjurylegalteam.pantheonsite.io',
		'dev'   : 'dev-vaccineinjurylegalteam.pantheonsite.io',
		'local' : 'vaccineinjurylegalteam.colab',
		'sync'  : 'vaccineinjurylegalteam.colab:3000',
		'xip'   : 'vaccineinjurylegalteam.colab.192.168.1.105.xip.io'
	},
	delete: {
		dest : 'dist'
	},
	styles: {
		src  : 'assets/styles',
		dest : 'dist/styles'
	},
	scripts: {
		src  : 'assets/scripts',
		dest : 'dist/scripts',
		entries: {
			// carbon_header_scripts : 'carbon_header_scripts.js',
			// carbon_scripts        : 'carbon_scripts.js'
			'carbon-scripts-modernizr' : 'modernizr.js',
			'carbon-scripts-admin'     : 'admin.js',
			'carbon-scripts-login'     : 'login.js',
			'carbon-scripts-theme'     : 'theme.js',
			// 'carbon-scripts-editor' : [
			// 	// 'assets/scripts/editor/tinymce.typekit.js',
			// ],
			// 'carbon-scripts-vendor'    : 'vendor.js'
			// 'carbon-scripts-vendor' : [
			// 	// 'assets/scripts/vendor/jquery.fresco-2.1.2.light.min.js',
			// 	// 'assets/scripts/vendor/jquery-jvectormap-2.0.4.min.js',
			// 	// 'assets/scripts/vendor/jquery-jvectormap-world-mill.js',
			// 	// 'assets/scripts/vendor/jquery.magnific-popup-1.0.1.min.js',
			//	// 'assets/scripts/vendor/jquery.swipebox-1.4.4.min.js',
			// ],
		}
	},
	pipeline: {
		fonts: {
			src  : 'assets/fonts/**/*',
			dest : 'dist/fonts'
		},
		images: {
			src  : 'assets/images/**/*.{png,gif,jpg,jpeg,ico}',
			dest : 'dist/images'
		},
		svg: {
			src  : 'assets/images/**/*.svg',
			dest : 'dist/images'
		},
		svgSprite: {
			src  : [
				'assets/images/sprite/**/*.svg',
				// 'assets/images/social/facebook.svg',
				// 'assets/images/social/twitter.svg',
				// 'assets/images/social/googleplus.svg',
				// 'assets/images/social/linkedin.svg'
			],
			dest : 'dist/images'
		}
	},
	watch: {
		scripts : 'assets/scripts/**/*.js',
		styles  : 'assets/styles/**/*.scss',
		fonts   : 'assets/fonts/**/*',
		images  : 'assets/images/**/*.{png,gif,jpg}',
		svg     : 'assets/images/**/*.svg',
		icons   : 'assets/icons/**/*.svg',
		public  : 'dist/**/*',
		php     : '**/*.php'
	}
};
